@use "sass:color";
@use '~@frontrow/console/css/variables.scss';

.sidebarLink {
  padding-top: variables.$std-padding-xxs;
  padding-bottom: variables.$std-padding-xxs;
  padding-left: variables.$std-padding-md;
}

.sidebarLinkA {
  font-size: variables.$font-size-lg;
  color: variables.$white;
}

.sidebarLinkA:hover {
  color: color.adjust(variables.$white, $lightness: -30%);
  text-decoration: none;
}

.sidebarLinkA:active {
  color: #404041;
  text-decoration: none;
}
